import { computed } from '@vue/composition-api'
import useCurrentData from '@/views/composable/useCurrentData'

/**
 * 権限チェック用のコンポーザブル
 * userAbilitiesを使用して、ユーザーが特定のアクションを実行できるかどうかを判定する
 */
export default () => {
  const { userAbilities } = useCurrentData()

  /**
   * 指定されたサブジェクトとアクションに対する権限を持っているかチェック
   * @param {string|string[]} subjects - チェック対象のサブジェクト（単一または配列）
   * @param {string} action - チェック対象のアクション（デフォルト: 'read'）
   * @returns {boolean} 権限があればtrue
   */
  const canPerform = (subjects, action = 'read') => {
    if (!userAbilities.value) return false

    const subjectArray = Array.isArray(subjects) ? subjects : [subjects]

    return userAbilities.value.some(
      ability => subjectArray.includes(ability.subject) && ability.action === action,
    )
  }

  /**
   * 顧客統計の閲覧権限を持っているかチェック
   * 'customer:stats' の read 権限があればtrue（有料機能）
   */
  const canViewCustomerStats = computed(() => {
    return canPerform('customer:stats', 'read')
  })

  /**
   * 顧客管理の権限を持っているかチェック
   * 'customer' または 'customer:management' の read 権限があればtrue
   */
  const canViewCustomerManagement = computed(() => {
    return canPerform(['customer', 'customer:management'], 'read')
  })

  return {
    canPerform,
    canViewCustomerStats,
    canViewCustomerManagement,
    userAbilities,
  }
}
